import { Dropdown, Menu } from 'antd'
import React, { useRef, useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ChartExportItemTP, ChartZipRatioTP, downloadChartsAsZip } from 'modules/reports/components/charts/chart-export/ChartImageExportUtils'

interface ICPProps {
    getCharts: () => ChartExportItemTP[]
    zipName?: string
    title?: string
}

const ZIP_RATIO_OPTIONS: Array<{ ratio: ChartZipRatioTP, label: string }> = [
    { ratio: 'full', label: 'Full' },
    { ratio: '16:9', label: '16:9' },
    { ratio: '4:3', label: '4:3' },
]

/**
 * Menu que baixa todos os graficos da tela num .zip, na proporcao escolhida.
 */
export function ButtonDownloadAllChartsCP(props: ICPProps): JSX.Element {

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const isExportingRef = useRef(false)

    /**
     */
    async function onClickDownload(ratio: ChartZipRatioTP): Promise<void> {

        if (isExportingRef.current)
            return

        const charts = props.getCharts()
        if (!charts.length) {
            NotificationHelper.warning('Atenção', 'Nenhum gráfico disponível para baixar.')
            return
        }

        isExportingRef.current = true
        setIsLoading(true)
        try {
            await downloadChartsAsZip(charts, props.zipName ?? 'series_historicas.zip', ratio)
        } catch (error) {
            NotificationHelper.error('Erro', 'Não foi possível gerar o arquivo com as imagens dos gráficos.')
        } finally {
            isExportingRef.current = false
            setIsLoading(false)
        }
    }

    return (
        <Dropdown
            trigger={['click']}
            overlay={
                <Menu>
                    {ZIP_RATIO_OPTIONS.map((option) => (
                        <Menu.Item
                            key={option.ratio}
                            disabled={isLoading}
                            onClick={() => onClickDownload(option.ratio)}
                        >
                            {option.label}
                        </Menu.Item>
                    ))}
                </Menu>
            }
        >
            <span>
                <ButtonCP
                    icon={'file-zip'}
                    loading={isLoading}
                >
                    {props.title ?? 'Baixar todas as imagens (.zip)'}
                </ButtonCP>
            </span>
        </Dropdown>
    )
}
